import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import cpVTScan from "../../../../assets/img/dtrfCP.png";
import signature from "../../../../assets/img/cachet.png";
import axiosInstance from "../../../../variables/api/axiosInstance";
import { frenchDateOnly, transformImmatriculation, numeroPoliceAffichage } from "../../../../variables/functions";
import AntidateBadge from "./AntidateBadge";
import DuplicataStamp from "./DuplicataStamp";

const DTRFWPPFormat = React.forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const [primeRC, setPrimeRC] = useState(0);
  const [primeIndC, setPrimeIndC] = useState(0);
  const [primeNette, setPrimeNette] = useState(0);
  const [taxes, setTaxes] = useState(0);
  const [primeTotale, setPrimeTotale] = useState(0);

  useEffect(() => {
    var dts = [];
    var puissance = 0;
    props.contrat?.engins &&
      (puissance = props?.contrat?.engins[0].puissance
        ? props?.contrat?.engins[0].puissance
        : props?.contrat?.engins[0].volume
          ? props?.contrat?.engins[0].volume
          : 0);
    console.log("Puissance: ", puissance);
    var categorieId = 0;
    props.contrat?.engins &&
      (categorieId = props?.contrat?.engins[0]?.categorie?.categorieId);
    axiosInstance
      .get(`/api/sous-garantie/compulsory-guaranties/${puissance}/${categorieId}`)
      .then((res) => {
        // console.log("Dataaaaa: ", res.data);
        res.data.forEach((cg, cgi) => {
          dts.push({
            key: `${cgi + dts.length}`,
            garantie: `${cg?.nom}`,
            capital: cg?.capital
              ? cg?.nom !== "RC"
                ? `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(cg?.capital)}`
                : "-"
              : "-",
            franchise: 0,
            bns: 0,
            reduc_comm: 0,
            reduc_flotte: 0,
            prime_nette: `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(
              cg?.primeNette,
            )}`,
          });
        });

        props?.contrat?.engins?.forEach((eng) => {
          eng.sousGaranties.forEach((sousGarantie, idx) => {
            if (
              sousGarantie?.garantie?.nom === "Incendie" ||
              sousGarantie?.garantie?.nom === "Vol"
            ) {
              var pNette = sousGarantie?.primeNette
                ? sousGarantie?.primeNette
                : sousGarantie?.tauxPCent
                  ? (sousGarantie?.tauxPCent * eng.valeurDeclaree) / 100
                  : eng.tauxPMille
                    ? (sousGarantie?.tauxPMille * eng.valeurDeclaree) / 1000
                    : 0.0;

              dts.push({
                key: `${idx + dts.length}`,
                garantie: `${sousGarantie?.garantie?.nom === "Individuel Conducteur"
                  ? sousGarantie?.nom
                  : sousGarantie?.garantie?.nom
                  }`,
                capital: sousGarantie.tauxPCent
                  ? `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(
                    (sousGarantie.primeNette * 100) / sousGarantie.tauxPCent,
                  )}`
                  : sousGarantie.tauxPMille
                    ? `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(
                      (sousGarantie.primeNette * 1000) /
                      sousGarantie.tauxPMille,
                    )}`
                    : "-",
                franchise: 0,
                bns: 0,
                reduc_comm: 0,
                reduc_flotte: 0,
                prime_nette: `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(pNette)}`,
              });
            } else {
              dts.push({
                key: `${idx + dts.length}`,
                garantie: `${sousGarantie?.garantie?.nom === "Individuel Conducteur"
                  ? sousGarantie?.nom
                  : sousGarantie?.garantie?.nom
                  }`,
                capital: sousGarantie.tauxPCent
                  ? `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(
                    (sousGarantie.primeNette * 100) / sousGarantie.tauxPCent,
                  )}`
                  : sousGarantie.tauxPMille
                    ? `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(
                      (sousGarantie.primeNette * 1000) /
                      sousGarantie.tauxPMille,
                    )}`
                    : "-",
                franchise: 0,
                bns: 0,
                reduc_comm: 0,
                reduc_flotte: 0,
                prime_nette: `${new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(
                  sousGarantie.primeNette,
                )}`,
              });
            }
          });
        });
        setData(dts);
        // console.log("DTS: ", dts);
        setPrimeIndC(dts?.find((el) => el.garantie !== "RC")?.prime_nette);
        setPrimeRC(dts?.find((el) => el.garantie === "RC")?.prime_nette);
        const primeN =
          parseFloat(dts?.find((el) => el.garantie !== "RC")?.prime_nette) +
          parseFloat(dts?.find((el) => el.garantie === "RC")?.prime_nette);
        // console.log("Prime nettte: ", primeN * 1000 + 2000);
        setPrimeNette(primeN * 1000);
        setTaxes(Math.trunc((primeN * 1000 + 2000) * 0.06));
        setPrimeTotale(Math.trunc((primeN * 1000 + 2000) * 1.06));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props?.contrat]);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <AntidateBadge contrat={props.contrat} />
      <DuplicataStamp contrat={props.contrat} />
      <div
        style={{
          width: "210mm",
          height: "297mm",
          backgroundImage: `url(${cpVTScan})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          position: "absolute",
        }}
      >
        <div className="row">
          <div className="col" style={{ position: "relative", left: "10px" }}>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "70px",
                marginTop: "133px",
              }}
            >
              <b>
                {`${props?.contrat?.producteur?.agence?.nom ? props?.contrat?.producteur?.agence?.nom : "DTRF Lomé"}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "500px",
                marginTop: "15px",
              }}
            >
              <b>
                {/* {`Imprimée le ${frenchDateOnly(new Date().toISOString())}`} */}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "350px",
                marginTop: "122px",
              }}
            >
              <b>
                {`${numeroPoliceAffichage(props.contrat)}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "635px",
                marginTop: "124px",
              }}
            >
              <b>{`${frenchDateOnly(props.contrat?.dateEffet)}`}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "635px",
                marginTop: "142px",
              }}
            >
              <b>{`${frenchDateOnly(props.contrat?.dateEcheance)}`}</b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "340px",
                marginTop: "143px",
              }}
            >
              <b>
                {`${props.contrat?.engins[0]?.concessionnaire?.raisonSociale ? props.contrat?.engins[0]?.concessionnaire?.raisonSociale : "-"}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "68px",
                marginTop: "293px",
              }}
            >
              <b>
                {`${props.contrat?.souscripteur?.nom} ${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.prenom : ""}`}{props.contrat?.souscripteur?.numeroAssureP ? ` (${props.contrat?.souscripteur?.numeroAssureP})` : null}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "590px",
                marginTop: "300px",
              }}
            >
              <b>
                {`${props.contrat?.producteur ? props.contrat?.producteur?.personne?.nom : ""}`}{" "}
                {`${props.contrat?.producteur ? (props.contrat?.producteur?.personne?.prenom ? props.contrat?.producteur?.personne?.prenom : "") : ""}`}{" "}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "100px",
                marginTop: "320px",
              }}
            >
              <b>
                {props?.contrat?.souscripteur?.profession
                  ? props?.contrat?.souscripteur?.profession
                  : "-"}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "350px",
                marginTop: "322px",
              }}
            >
              <b>
                {`${props.contrat?.souscripteur?.adresse ? props.contrat?.souscripteur?.adresse : "-"}`}
                {` ${props.contrat?.souscripteur?.contact && props.contrat?.souscripteur?.contact?.[0] !== undefined ? props.contrat?.souscripteur?.contact[0] : "-"}`}
              </b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "265px",
                marginTop: "371px",
              }}
            >
              <b>
                {`${transformImmatriculation(props.contrat?.engins[0]?.immatriculation).toUpperCase()}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "95px",
                marginTop: "398px",
              }}
            >
              <b>{`${props.contrat?.engins[0]?.marque}`}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "380px",
                marginTop: "398px",
              }}
            >
              <b>
                {`${props.contrat?.engins[0]?.carosserie ? props.contrat?.engins[0]?.carosserie : "CADRE"}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "630px",
                marginTop: "400px",
              }}
            >
              <b>
                {`${props.contrat?.engins[0]?.dateMiseEnCirculation ? props.contrat?.engins[0]?.dateMiseEnCirculation?.split("-")[0] : "2024"}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "95px",
                marginTop: "415px",
              }}
            >
              <b>
                {props.contrat?.engins[0]?.volume
                  ? `${props.contrat?.engins[0]?.volume}cm3`
                  : props.contrat?.engins[0]?.puissance}
              </b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "190px",
                marginTop: "418px",
              }}
            >
              <b>{`${props.contrat?.engins[0]?.energie}`}</b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "380px",
                marginTop: "418px",
              }}
            >
              <b>{`${props.contrat?.engins[0]?.numeroChassis?.toUpperCase()}`}</b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "90px",
                marginTop: "435px",
              }}
            >
              <b>{`${props.contrat?.engins[0]?.nombrePlace ? props.contrat?.engins[0]?.nombrePlace : "2"}`}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "190px",
                marginTop: "436px",
              }}
            >
              <b>
                {`${props.contrat?.engins[0]?.genre ? props.contrat?.engins[0]?.genre : "-"}`}
              </b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "385px",
                marginTop: "437px",
              }}
            >
              <b>{`${props.contrat?.engins[0]?.moteur?.toUpperCase()}`}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "93px",
                marginTop: "452px",
              }}
            >
              <b>
                {`${props.contrat?.engins[0]?.categorie?.codeCategorie?.startsWith("M") ? "5. MOTOS" : props.contrat?.engins[0]?.categorie?.codeCategorie}`}
              </b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "382px",
                marginTop: "454px",
              }}
            >
              <b>{`${props.contrat?.engins[0]?.usage}`}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "710px",
                marginTop: "540px",
              }}
            >
              <b>{data?.find((el) => el.garantie === "RC")?.prime_nette}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "710px",
                marginTop: "560px",
              }}
            >
              <b>Gratuit</b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "715px",
                marginTop: "730px",
              }}
            >
              <b>{data?.find((el) => el.garantie !== "RC")?.prime_nette}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "710px",
                marginTop: "775px",
              }}
            >
              <b>{new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(props.contrat?.primeNette)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "718px",
                marginTop: "795px",
              }}
            >
              <b>2.000</b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "718px",
                marginTop: "812px",
              }}
            >
              <b>{new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(taxes)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "710px",
                marginTop: "829px",
              }}
            >
              <b>{new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(props.contrat?.primeTotale)}</b>
            </h6>

            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "365px",
                marginTop: "869px",
              }}
            >
              <b>
                {`${props.contrat?.producteur ? (props.contrat?.producteur?.agence ? props.contrat?.producteur?.agence?.ville : "Lomé") : "Lomé"}
                , le ${frenchDateOnly(new Date().toISOString())}`}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "585px",
                marginTop: "969px",
              }}
            >
              <img style={{ width: "50%" }} src={signature} />
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
});
DTRFWPPFormat.propTypes = {
  contrat: PropTypes.object,
  engin: PropTypes.object,
  printing: PropTypes.bool,
};
DTRFWPPFormat.displayName = "Attestation VT";

export default DTRFWPPFormat;
